import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InvoiceRefundComponent } from './invoice-refund.component';


const routes: Routes = [
  {
    path: '', component: InvoiceRefundComponent
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceRefundRoutingModule { }
